import Vue from 'vue';
export function routerAfterEachFunc(to) {
	Vue.nextTick(() => {
		if (to.meta && to.meta.title) {
			document.title = to.meta.title;
		}
	});
}

export function routerBeforeEachFunc(to, from, next) {
	// console.log('xxx')
	if (to.meta && to.meta.title) {
		// 如果设置标题，拦截后设置标题
		document.title = to.meta.title;
	}
	// console.log('from ===', from);
	// console.log('to ===', to);
	next();
}
